@if (isMobile()) {
<app-page-modal-container goBackUrl="/schedule">
    <section class="pb-20 w-full">
        <!-- <app-customer-image-banner /> -->
        <ng-container *ngTemplateOutlet="content" />
    </section>
</app-page-modal-container>
} @else {
<app-customer-image-banner class="hidden xl:block" />

<app-container class="hidden xl:block pb-[3.5rem]">
    <ng-container *ngTemplateOutlet="content" />
</app-container>
}

<ng-template #content>
    <section class="container flex relative flex-col gap-4 px-4">
        <div class="sticky top-0 z-10 bg-white">
            <app-segment
                color="black"
                [options]="segments"
                [(value)]="segment"
                (valueChange)="handleRouteChange($event)"
            />
        </div>

        <router-outlet />
    </section>
</ng-template>
